<template>
    <div>
        <div v-html="renderedValue"></div>
        <div class="text-center">
            <button class="btn btn-link" v-if="!opened" @click="opened = true">
                {{ expandText }} <i class="fa fa-arrow-down"></i>
            </button>
            <button class="btn btn-link" v-if="opened" @click="opened = false">
                {{ collapseText }} <i class="fa fa-arrow-up"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String | null,
            required: true,
        },
        maxValues: {
            type: Number,
            required: false,
            default: 4,
        },
        expandText: {
            type: String,
            required: false,
            default: "Mostra tutti",
        },
        collapseText: {
            type: String,
            required: false,
            default: "Comprimi",
        },
    },

    computed: {
        renderedValue() {
            let value = this.value;
            if (!value) return "";
            value = value.toString();
            let names = value.split("\n");
            let string = "";
            for (let i = 0; i < names.length; i++) {
                if (!this.opened && i > this.maxValues) {
                    break;
                }
                let name = names[i].trim();
                if (name) {
                    string += `<li>${name}</li>`;
                }
            }
            return `<ul class="mb-0">${string}</ul>`;
        },
    },

    data: function () {
        return {
            opened: false,
        };
    },
};
</script>
